// App.js
import { React, useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaArrowUp, FaMoon, FaSun } from "react-icons/fa";
// import { FaMapMarkerAlt } from "react-icons/fa";

import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./App.css";

//Scroll Animation
import AOS from 'aos';
import 'aos/dist/aos.css';

import floorPlanningImg from "./images/floor-planning.jpg";
import layoutImg from "./images/layout.jpg";
import landMeasurementImg from "./images/land-measurement.jpg";
import structuralDetailImg from "./images/structural-detail.jpg";
import siteInspectionImg from "./images/site-inspection.jpg";
import costEstimationImg from "./images/cost-estimation.jpg";
import threeDDrawingImg from "./images/3d-drawing2.jpg";
import websiteDesignImg from "./images/web-design2.jpg";
import electricalWiringImg from "./images/electrical-design.jpg";
import logoImg from "./images/logo.png";
import rehanImg from './images/rehan-hayat.jpg';

const sections = [
  { id: "hero", label: "Home" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

const serviceData = [
  {
    title: "Floor Planning & Designing",
    image: floorPlanningImg,
    description: "We specialize in creating functional and visually appealing floor plans tailored to your lifestyle and space requirements."
  },
  {
    title: "Layout",
    image: layoutImg,
    description: "Our layout services are designed to maximize usability, accessibility, and compliance with all relevant building codes."
  },
  {
    title: "Land Measurement",
    image: landMeasurementImg,
    description: "Accurate land surveying using advanced tools ensures precise plotting and boundary definition for every type of property."
  },
  {
    title: "Structural Detail",
    image: structuralDetailImg,
    description: "We provide comprehensive structural detailing, including reinforcement drawings and load analysis for safety and durability."
  },
  {
    title: "Site Inspection",
    image: siteInspectionImg,
    description: "Thorough on-site inspections ensure that construction aligns with design, maintains quality, and follows proper standards."
  },
  {
    title: "Cost Estimation",
    image: costEstimationImg,
    description: "We offer accurate cost estimation services to help you plan and budget your project with confidence and transparency."
  },
  {
    title: "3D Drawing",
    image: threeDDrawingImg,
    description: "We create realistic 3D models and visualizations of your architectural projects for better understanding and presentation."
  },
  {
    title: "Website Design",
    image: websiteDesignImg,
    description: "We design modern, responsive, and user-friendly websites tailored to showcase your business professionally across all devices."
  },
  {
    title: "Electrical Wiring Design",
    image: electricalWiringImg,
    description: "Our electrical wiring layouts ensure safe, efficient, and code-compliant power distribution throughout your building."
  },
];


function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className="btn sticky-icon-btn top-btn position-fixed"
      style={{
        bottom: "30px",
        right: "20px",
        zIndex: "1030",
        display: visible ? "inline-block" : "none",
      }}
      aria-label="Scroll to top"
    >
      <FaArrowUp size={18} />
    </button>

  );
}


function FadeImage({ src, alt, className, style }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={className}
      style={{
        ...style,
        opacity: loaded ? 1 : 0,
        transition: "opacity 0.6s ease-in-out",
      }}
      onLoad={() => setLoaded(true)}
    />
  );
}


function ServiceCardSkeleton() {
  return (
    <div className="card h-100 shadow-sm">
      <div className="skeleton skeleton-img"></div>
      <div className="card-body">
        <div className="skeleton skeleton-title mb-2"></div>
        <div className="skeleton skeleton-text mb-1"></div>
        <div className="skeleton skeleton-text w-75"></div>
      </div>
    </div>
  );
}


export default function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
      offset: 100     // offset (px) from the bottom of screen
    });
  }, []);


  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true";
  });


  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
    document.body.classList.toggle("dark-theme", darkMode);
  }, [darkMode]);

  const [servicesLoading, setServicesLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setServicesLoading(false);
    }, 1000); // simulate loading

    return () => clearTimeout(timer);
  }, []);


  return (
    <div>
      {/* Sticky Side Buttons */}
      <div className="position-fixed start-0 top-50 translate-middle-y d-flex flex-column gap-2 z-3 ps-2">
        <a
          href="https://wa.me/918637202206"
          className="btn sticky-icon-btn whatsapp-btn"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
        >
          <FaWhatsapp size={20} />
        </a>
        <a
          href="tel:+918637202206"
          className="btn sticky-icon-btn call-btn"
          aria-label="Call"
        >
          <FaPhoneAlt size={18} />
        </a>
        <a
          href="mailto:rehanhayat16@gmail.com"
          className="btn sticky-icon-btn email-btn"
          aria-label="Email"
        >
          <FaEnvelope size={18} />
        </a>
      </div>


      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark fixed-top navbar-gradient">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center gap-2 fw-bold" href="#hero">
            <img src={logoImg} alt="Logo" style={{ height: "60px" }} />
            Hayat Architects
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-between" id="navbarNav">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {sections.map(({ id, label }) => (
                <li className="nav-item" key={id}>
                  <Link
                    to={id}
                    smooth={true}
                    duration={500}
                    offset={-70}
                    className="nav-link text-white"
                    onClick={() => {
                      const navbarToggler = document.querySelector(".navbar-toggler");
                      const navbarCollapse = document.querySelector(".navbar-collapse");
                      if (navbarToggler && navbarCollapse.classList.contains("show")) {
                        navbarToggler.click();
                      }
                    }}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* ✅ Toggle aligned independently */}
            <div className="d-flex align-items-center mt-3 mt-lg-0 ms-lg-4 ms-2">
              <div className="theme-toggle-switch">
                <input
                  type="checkbox"
                  id="themeToggle"
                  checked={darkMode}
                  onChange={() => setDarkMode(!darkMode)}
                />
                <label htmlFor="themeToggle" className="switch">
                  <span className="slider">
                    {darkMode ? (
                      <FaSun className="toggle-icon" />
                    ) : (
                      <FaMoon className="toggle-icon" />
                    )}
                  </span>
                </label>
              </div>
            </div>
          </div>

        </div>
      </nav>

      {/* Hero Section */}
      <section id="hero" className="hero-section">
        <div className="container text-white text-center">
          <h1 className="display-3 fw-bold">
            <span className="text-warning">Hayat Architects</span>
            <br></br>
            <span className="display-4 fw-bold">Designing Spaces. Defining Futures.</span>
          </h1>
          <p className="lead">
            We provide expert architecture services from floor planning to
            structural detail with precision and style.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-5 bg-light" data-aos="fade-up">
        <div className="container">
          <h2 className="text-center mb-4 fw-bold">Our Services</h2>
          <div className="row">
            {servicesLoading
              ? Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="col-md-6 col-lg-4 mb-4">
                  <ServiceCardSkeleton />
                </div>
              ))
              : serviceData.map(({ title, image, description }) => (
                <div key={title} className="col-md-6 col-lg-4 mb-4">
                  <div className="card h-100 shadow-sm service-card">
                    <img
                      src={image}
                      alt={title}
                      className="card-img-top object-fit-contain p-3"
                      style={{ height: "200px" }}
                    />
                    <div className="card-body">
                      <h5 className="card-title fw-semibold">{title}</h5>
                      <p className="card-text">{description}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      <section className="why-section py-5" data-aos="fade-up">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Choose Us</h2>

          <div className="row g-4">
            <div className="col-md-6 col-lg-3">
              <div className="why-card h-100 p-4 text-center">
                <h5 className="fw-semibold">Innovative & Practical Designs</h5>
                <p className="mb-0">
                  We blend creativity with smart planning to deliver structures that
                  are beautiful, functional, and future-ready.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="why-card h-100 p-4 text-center">
                <h5 className="fw-semibold">Realistic 3D Visualization</h5>
                <p className="mb-0">
                  Experience your project before construction begins with detailed
                  and accurate 3D architectural models.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="why-card h-100 p-4 text-center">
                <h5 className="fw-semibold">Client-Focused Approach</h5>
                <p className="mb-0">
                  We listen carefully to your vision and design according to your
                  needs, preferences, and budget.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="why-card h-100 p-4 text-center">
                <h5 className="fw-semibold">Transparent & Timely Delivery</h5>
                <p className="mb-0">
                  Clear communication, structured workflow, and commitment to
                  deadlines ensure smooth execution.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-5">
        <div className="container">
          <h2 className="text-center mb-4 fw-bold">About Us</h2>
          <div className="row align-items-center">
            <div className="col-md-4 text-center mb-4 mb-md-0">
              <FadeImage
                src={rehanImg}
                alt="Rehan Hayat"
                className="img-fluid rounded-circle shadow"
                style={{ maxWidth: "250px" }}
              />
              <h5 className="mt-3 fw-semibold">Rehan Hayat</h5>
              <p className={darkMode ? "text-secondary" : "text-muted"}>Founder & Civil Engineer</p>
            </div>
            <div className="col-md-8">
              <p>
                <b>Hayat Architects</b> is led by <b>Rehan Hayat</b>, a highly accomplished civil engineer
                with a B.Tech degree in Civil Engineering and over <b>8 years</b> of extensive
                experience in the architecture and construction industry. His deep-rooted
                expertise in structural design, project execution, and sustainable development
                forms the foundation of the firm’s philosophy.
              </p>
              <p>
                At Hayat Architects, we are committed to delivering intelligent, functional,
                and aesthetically refined architectural solutions tailored to the unique needs
                of each client. From concept to completion, every project is approached with
                precision, creativity, and an unwavering focus on quality—ensuring spaces that
                not only stand the test of time but also elevate the way people live and work.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Contact Section */}
      <section id="contact" className="py-5 bg-light">
        <div className="container text-center">
          <h2 className="mb-4 fw-bold">Contact Us</h2>
          <p className="mb-3">Have a project in mind? We'd love to hear from you.</p>
          <p>
            <a href="tel:+918637202206"
              className={`text-decoration-none fw-semibold ${darkMode ? "text-light" : "text-dark"}`}
            >
              <FaPhoneAlt className="me-2 text-primary" />
              +91 86372 02206
            </a>
          </p>
          <p>
            <a
              href="tel:+917008047762"
              className={`text-decoration-none fw-semibold ${darkMode ? "text-light" : "text-dark"}`}
            >
              <FaPhoneAlt className="me-2 text-primary" />
              +91 70080 47762
            </a>
          </p>
          <p className="mb-2">
            <span className="fw-semibold">Office Address: </span>
            <span className={darkMode ? "text-secondary" : "text-muted"}>Gandhi chowk, Champua, Odisha - 758041</span>
          </p>
          {/* <a
            href="https://www.google.com/maps?q=123+Main+Road,+Jamshedpur,+Jharkhand+831001"
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none text-primary fw-medium"
          >
            <FaMapMarkerAlt className="me-2 text-danger" />
            View on Google Maps
          </a> */}
          <br></br>
          <div className="map-container">
            <iframe
              title="Hayat Architecture Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3697.572798867325!2d85.66330157433735!3d22.06593145135144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1e4d0049c31f79%3A0x4c8bbf74c04606ff!2sHayat%20Architecture%20Services!5e0!3m2!1sen!2sin!4v1771865366855!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-white py-3">
        <div className="container text-center">
          <small>
            &copy; {new Date().getFullYear()} Hayat Architects. All rights
            reserved.
          </small>
        </div>
      </footer>
      <ScrollToTopButton />
    </div>
  );
}
